import { PrismicImage, PrismicRichText } from "@prismicio/react";

/**
 * @typedef {import("@prismicio/client").Content.ArticleCardSlice} ArticleCardSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<ArticleCardSlice>} ArticleCardProps
 * @param {ArticleCardProps}
 */
const ArticleCard = ({ slice, index }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      <div className={`bg-${slice.primary.bg_color} rounded-[22px] mx-4 md:mx-7 lg:mx-0 px-10 py-30px article-card mb-10 md:mb-[60px] md:flex`}>
        {slice.primary.picto && <PrismicImage field={slice.primary.picto}
          alt={slice.primary.picto.alt} className="w-[80px] h-[80px] object-contain mb-5 md:mb-0 md:mr-5"   loading={index === 0 ? '' : 'lazy'}/>
        }
        <div>
          <PrismicRichText field={slice.primary.text} />
        </div>
      </div>
    </section>
  );
};

export default ArticleCard;
